import { createContext } from 'react';

const HeaderSearchContext = createContext<HTMLElement | null | undefined>(
  undefined
);

export default HeaderSearchContext;
